import { CARD_TRANSACTION_CATEGORY_ICON_MAP } from "constants/cardTransactions";
import React from "react";
import {
  ApiCardTransaction,
  ApiCardTransactionSource,
} from "utils/api/cardTransactions";
import { formatCurrency } from "utils/string";
import Icon from "../Icon";
import UILabel from "../UILabel";
import * as Styled from "./styled";

interface Props extends ApiCardTransaction {
  showBadge?: boolean;
}

const Transaction: React.FC<Props> = ({
  amount,
  merchantName,
  merchantCategory,
  source,
  showBadge,
}) => {
  const absAmount = Math.abs(amount);
  const isCredit = amount < 0;
  const icon =
    CARD_TRANSACTION_CATEGORY_ICON_MAP[merchantCategory] || "shoppingBag";

  return (
    <Styled.Wrapper>
      <Styled.Inner>
        <Styled.IconWrapper>
          <Icon name={icon} color="primary" />
        </Styled.IconWrapper>

        <Styled.Main>
          <UILabel.XLarge color={isCredit ? "credit" : "text"}>
            {isCredit ? "+" : ""}${formatCurrency(absAmount)}
          </UILabel.XLarge>
          <UILabel.Small>{merchantName || merchantCategory}</UILabel.Small>
        </Styled.Main>

        {showBadge && source === ApiCardTransactionSource.ewa && (
          <Styled.TagWrapper>
            <Styled.Tag>
              <UILabel.Small>Payday</UILabel.Small>
              <Icon name="clock" size="xs" />
            </Styled.Tag>
          </Styled.TagWrapper>
        )}
      </Styled.Inner>
    </Styled.Wrapper>
  );
};

export default Transaction;
